import type { IconName } from '../shared/icons';
import { CONFIG_DEFAULTS } from '../global/config-defaults';
import { getCachedResource } from './services/resource-cache.service';

/**
 * @name Get Icon
 *
 * @description Get the URL of an SVG icon file.
 * On browser, it uses the `window.workbench.iconRootPath` configuration.
 * On server, it uses the default configuration.
 *
 * @example
 * import { getIconSvgUrl, getIconSvgContent } from '@workbench/core';
 *
 * const url = getIconSvgUrl('bds/business-case/24');
 * // url = 'https://assets.oneweb.mercedes-benz.com/plugin/workbench/assets/4.7.1/icons/bds/business-case/24.svg'
 *
 * const icon = await getIconSvgContent('bds/business-case/24');
 * // icon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 10v4h-2v-4zm-3 0V9h4v1h8V8a1 1 0 0 0-1-1h-5V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H3a1 1 0 0 0-1 1v2zm-.5-4.5h5V7h-5zM14 11v4h-4v-4H2v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8z"/></svg>`
 */

/**
 * Get the URL of an SVG icon file.
 * On browser, it uses the `window.workbench.iconRootPath` configuration.
 * On server, it uses the default configuration.
 */
export const getIconSvgUrl = (iconName: IconName): string => `${CONFIG_DEFAULTS.iconRootPath}/${iconName}.svg`;

/**
 * Get the content of an SVG icon file.
 */
export const getIconSvgContent = (iconName: IconName): Promise<string> => getCachedResource(getIconSvgUrl(iconName));
